import ActivityLogView from '../activityLogs/ActivityLogView';

/**
 * Activity Logs — every create, update and delete performed from the portal,
 * by Admins and the Super Admin alike. The role tabs inside narrow the view.
 */
const AdminActivityLogs = () => (
  <ActivityLogView description="Every create, update and delete performed from the portal. Use the tabs to narrow by who performed the action. Sign-in activity is not recorded." />
);

export default AdminActivityLogs;
